export const strings = {
  en: {
    beamAttribution: () => `Powered by Beam`,
    ctaTitle: () => `Choose your impact`,
    ctaPromoPrefixMessage: () => `At no extra cost,`,
    ctaPromoMessage: ({ donationPercentage = "1" } = {}) =>
      `select a nonprofit and ${donationPercentage}% of your purchase will be donated.`,
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `At no extra cost, select a nonprofit and ${donationPercentage}% of your purchase will be donated.`,
    inlineSeparator: () => `: `,
  },
  fr: {
    beamAttribution: () => `Optimisé par Beam`,
    ctaTitle: () => `Choisissez votre cause`,
    ctaPromoPrefixMessage: () => ``,
    ctaPromoMessage: () => ``,
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `Sans frais supplémentaires, choisissez un organisme à but non lucratif et ${donationPercentage} % lui sera versé en votre nom.`,
    inlineSeparator: () => ` : `,
  },
  de: {
    beamAttribution: () => `Unterstützt von Beam`,
    ctaTitle: () => `Wähle deinen Impact`,
    ctaPromoPrefixMessage: () => ``,
    ctaPromoMessage: () => ``,
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `Ohne zusätzliche Kosten, wähle eine der gemeinnützigen Organisationen und spende ${donationPercentage}% deines Einkaufs`,
    inlineSeparator: () => `: `,
  },
  es: {
    beamAttribution: () => "Ofrecido por Beam",
    ctaTitle: () => "Elige tu contribución",
    ctaPromoPrefixMessage: () => ``,
    ctaPromoMessage: () => ``,
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `Sin coste adicional, elige una organización sin fines de lucro y donaremos ${donationPercentage}% de tu compra.`,
    inlineSeparator: () => ": ",
  },
  it: {
    beamAttribution: () => "Gestito da Beam",
    ctaTitle: () => "Scegli dove fare la differenza",
    ctaPromoPrefixMessage: () => ``,
    ctaPromoMessage: () => ``,
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `Senza costi aggiuntivi, seleziona un'organizzazione no-profit a cui devolvere l’${donationPercentage}% del tuo acquisto`,
    inlineSeparator: () => ": ",
  },
  pl: {
    beamAttribution: () => `Wspierany przez Beam`,
    ctaTitle: () => `Wybierz inicjatywę, którą chcesz wesprzeć`,
    ctaPromoPrefixMessage: () => ``,
    ctaPromoMessage: () => ``,
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `Bez żadnych dodatkowych kosztów wybierz organizację, której przekażesz ${donationPercentage}% wartości Twoich zakupów!`,
    inlineSeparator: () => `: `,
  },
};
